import { SimpleDocCommand } from '../../apps/DocsApp/commands/v5/types';
import { StandardToolResult } from '../../types/standardToolResults';
import { CommandExecutionContext } from '../../types/commands';
import { getApplicationForEntity } from '../../services/applicationRegistry';

export const entity_format_clear: SimpleDocCommand = {
  id: 'entity_format_clear',
  logicalName: 'entity_format_clear',
  version: 'v2',

  description: 'Clear text formatting from an entity.',

  schema: {
    parameters: [
      { name: 'entityId', type: 'string', description: 'Entity ID.', required: true },
      { name: 'target', type: 'object', description: '{ all: true } | { nodeId: "X" } | { nodeIds: [...] } | { className: "X" }.', required: true },
      { name: 'formats', type: 'array', description: 'CSS properties to clear (camelCase). Example: ["backgroundColor", "color"]. Omit to clear all.', required: false }
    ]
  },

  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { entityId, target, formats } = params;
    const app = await getApplicationForEntity(entityId);
    if (!app) return { status: 'error', message: 'Entity not found or not a v2 entity', format: 'plaintext' };
    const result = await app.handleEntityFormatClear(target, formats);
    return { status: 'success', message: `Formatting cleared from ${result.affectedNodes.length} nodes`, data: { entityId, affectedNodes: result.affectedNodes, formatsCleared: formats || 'all' }, format: 'json' };
  }
};
